import { ApiProperty } from '@nestjs/swagger';
import { SpSubdivisionNameInterface } from '../interfaces/sp-subdivision-name.interface';
import { IsBoolean, IsUUID, MaxLength } from 'class-validator';
import { CommonEntityDto } from '../../../common/dto/common-entity.dto';
import { SubdivisionDto } from '../../../subdivision/dto/subdivision.dto';
import { BuilderDto } from '../../../builder/dto/builder.dto';

export class SpSubdivisionNameDto
  extends CommonEntityDto
  implements SpSubdivisionNameInterface
{
  @ApiProperty({ required: true })
  @MaxLength(250, {
    message: 'The spName field is required and must not exceed 250 characters',
  })
  spName!: string;

  @ApiProperty({ type: 'string', name: 'Sp Name Id' })
  spNameId!: string;

  @ApiProperty({ required: true })
  @IsUUID()
  subdivisionId!: string;

  @ApiProperty({ required: true })
  @IsUUID()
  builderId!: string;

  @ApiProperty({
    type: 'boolean',
    default: true,
    title: 'Active?',
    description: 'True if subdivision name is active',
  })
  @IsBoolean()
  active!: boolean;

  @ApiProperty({ type: () => SubdivisionDto })
  subdivision?: SubdivisionDto;

  @ApiProperty({ type: BuilderDto })
  builder?: BuilderDto;
}
